<p-toast [life]="5000" mode="expanded" [autoZIndex]="true" appendTo="body" class="network-aware-toast" stackVisibleLimit="8"/>
<network-status-banner />
<router-outlet />
<app-main />
<p-confirm-dialog>
    <ng-template #headless let-message let-onAccept="onAccept" let-onReject="onReject">
        <div
            class="flex flex-col items-center p-8 bg-surface-0 dark:bg-surface-900 rounded-xl shadow-lg border border-surface-200 dark:border-surface-700">

            <!-- Ícono Superior -->
            <div
                class="rounded-full bg-primary-100 dark:bg-primary-900/30 text-primary-600 dark:text-primary-400 inline-flex justify-center items-center h-16 w-16 mb-4">
                <i [class]="message.icon || 'pi pi-exclamation-circle'" class="!text-3xl"></i>
            </div>

            <!-- Título del Diálogo -->
            <span class="font-bold text-2xl text-surface-900 dark:text-surface-0 block mb-2">
                {{ message.header }}
            </span>

            <!-- Mensaje Principal -->
            <p class="mb-0 text-surface-600 dark:text-surface-300 text-center max-w-sm">
                {{ message.message }}
            </p>
            <!-- Botones de Acción -->
            <p-divider />
            <div class="flex items-center gap-3 mt-2">
                <button pButton [severity]="message.rejectButtonProps?.severity || 'secondary'" size="small" (click)="onReject()"><i
                        [class]="message.rejectButtonProps?.icon || 'pi pi-times'"></i>
                    {{message.rejectButtonProps?.label || 'Cancelar'}}</button>

                <button pButton [severity]="message.acceptButtonProps?.severity || 'primary'" size="small"
                    (click)="onAccept()">
                    <i [class]="message.acceptButtonProps?.icon || 'pi pi-check'"></i>
                    {{message.acceptButtonProps?.label || 'Guardar'}}</button>
            </div>
        </div>
    </ng-template>
</p-confirm-dialog>

<!-- Sinner  -->
@if(spinnerService.isLoading()) {
<app-spinner />
}